import { axiosInstance, authHeader, handleResponse, handleError } from '../helpers';
import { api } from '../constants'

export const classService = {
    getClassList,
    createClass,
    updateClass,
    deleteClass,
    clearChathistory,
    activateClass
};

function getClassList() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return axiosInstance.get(api.classes.getclasslist, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}


function createClass(classDetails) {

    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    };

    return axiosInstance.post(api.classes.addclassdetails, classDetails, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function updateClass(classDetails) {
    const requestOptions = {
        method: 'put',
        headers: authHeader()
    };

    return axiosInstance.put(api.classes.updateclassroom, classDetails, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function deleteClass(classId) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return axiosInstance.delete(`${api.classes.deleteClass}/${classId}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function clearChathistory(submissionData) {
    const requestOptions = {
        method: 'post',
        headers: authHeader()
    };

    return axiosInstance.post(api.chathistory.clearChat, submissionData, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function activateClass(classDetails) {
    const requestOptions = {
        method: 'put',
        headers: authHeader()
    };

    return axiosInstance.put(api.classes.activateClass, classDetails, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}